// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 418 ? "video-compressor" : chunkId) + "." + {"418":"cbf6253c","956":"99408a05"}[chunkId] + ".js";
};